<template>
  <div class="certifikat ovoj" id="html">

    <div class="levi-stolpec">
      <div class="levi-stolpec-napis">
        <div class="eko-napis"></div>
      </div>
    </div>

    <div id="prvi-del">
      <!-- <div class="levi-logo">
          <img src='~@/assets/ikc.png'/>
        </div>-->

      <div class="glava mali-ovoj">

        <div class="glava certifikat">
          <h1>{{ __("CERTIFIKAT") }}</h1>

        </div>
        <div class="desni-logo">

        </div>

      </div>

      <!--<div class="levi-stolpec">
      <div class="eko-napis">Ekološko kmetijstvo</div>
     </div>
   -->

      <!-- 1-4 -->
      <div class="celotna-sekcija">
        <div class="identifikacija sekcija">
          <div class="vrstica del-1">
            <div class="stevilka-certifikata">
              <div class="naslov kategorija">{{ __("Številka dokumenta:") }}</div>
              <div class="stevilka-certifikata">{{ certifikat.stcertifikata }}</div>
            </div>
            <div class="vrsta-certifikata">{{ __(certifikat.vrstacertifikata) }}</div>
          </div>
          <div class="vrstica del-2">
            <!-- en ali več-->
            <div class="nosilec">

              <div class="naslov kategorija">{{ __("Ime in naslov izvajalca dejavnosti:") }}</div>
              <div v-if="certifikat.subjekt_maticna_naziv" class="naziv-nosilca">{{ certifikat.subjekt_maticna_naziv }}
              </div>
              <div v-if="certifikat.subjekt_maticna_naslov" class="naslov-nosilca">{{ certifikat.subjekt_maticna_naslov
              }}
              </div>
              <div class="naziv-nosilca">{{ certifikat.subjekt_naziv }}</div>
              <div class="naslov-nosilca">{{ certifikat.subjekt_naslov }}</div>


            </div>
            <div class="izvajalec">
              <div class="naslov">{{ __("Ime in naslov izvajalca nadzora ter šifra:") }}</div>
              <div class="naziv-izvajalca">{{ certifikat.organ_ime }}</div>
              <div class="naslov-izvajalca">{{ certifikat.organ_naslov }}</div>
              <div class="sifra-izvajalca">{{ certifikat.organ_sifra }}</div>
            </div>

          </div>

        </div>

        <!--
      <div class="noga-izven">
        <div class="stevilka-strani" :class="jezik"></div>
        
      </div>
       5 -->
        <div class="dejavnosti-izvajalca sekcija">

          <div class="naslov kategorija" v-if="certifikat.vrstacertifikata == 'Izvajalec dejavnosti'">{{ __("Dejavnosti izvajalca dejavnosti: ")}}</div>
          <div class="naslov kategorija" v-if="certifikat.vrstacertifikata != 'Izvajalec dejavnosti'">{{ __("Dejavnosti skupine izvajalcev dejavnosti: ")}}</div>
          <ul>
            <li v-for="(dejavnost, i) in certifikat.dejavnosti">
              {{ __(dejavnost) }}
            </li>

          </ul>
        </div>
        <!-- 6 -->
        <div class="kategorije-proizvodov sekcija">
          <div class="naslov kategorija">
            {{ __("Kategorije proizvodov iz člena 35(7) Uredbe (EU) 2018/848 Evropskega parlamenta in Sveta (1) ter metode pridelave: ")}}
          </div>

          <kategorija :podatki="certifikat.rastline"
            :naslov="__('(a) nepredelane rastline in rastlinski proizvodi, vključno s semeni in drugim rastlinskim razmnoževalnim materialom')" />
          <kategorija :podatki="certifikat.živali" :naslov="__('(b) živina in nepredelani proizvodi iz živine')" />
          <kategorija :podatki="certifikat.alge" :naslov="__('(c) alge in nepredelani proizvodi iz akvakulture')" />
          <kategorija :podatki="certifikat.proizvodi"
            :naslov="__('(d) predelani kmetijski proizvodi, vključno s proizvodi iz akvakulture, namenjeni za hrano')"
            proizvod="true" />
          <kategorija :podatki="certifikat.krma" :naslov="__('(e) krma')" proizvod="true" />
          <kategorija :podatki="certifikat.vino" :naslov="__('(f) vino')" proizvod="true" />
          <kategorija :podatki="certifikat.ostalo"
            :naslov="__('(g) ostali proizvodi iz Priloge I k Uredbi (EU) 2018/848 ali proizvodi, ki ne spadajo v prej navedene kategorije')"
            proizvod="true" />
        </div>
      </div>
    </div>
    <div id="drugi-del">
      <div class="celotna-sekcija">
        <div
          v-if="proizvodi.filter(p => (!(p.kategorija == 'b' && p.statuspridelkanaziv == 'Iz preusmeritve') && p.statuspridelkanaziv != '1. leto preusmeritve')).length > 0"
          class="seznam seznam-proizvodov sekcija">
          <div class="naslov-kategorije">
            {{ __("Seznam proizvodov") }}
          </div>
          <table cellspacing="0">
            <thead>
              <tr>
                <td>{{ __("Ime proizvoda in/ali oznaka kombinirane nomenklature (KN) iz Uredbe Sveta (EGS) št. 2658/87 za proizvode s področja uporabe Uredbe(EU) 2018 / 848")}}</td>
                <td>{{ __("Status") }}</td>
              </tr>
            </thead>

            <template v-for="kategorija in certifikat.kategorije"
              v-if="proizvodi.filter(p=>(p.kategorija==kategorija.id&&!(kategorija.id=='b'&&p.statuspridelkanaziv=='Iz preusmeritve')&&p.statuspridelkanaziv!='1. leto preusmeritve')).length>0">
              <tbody>
                <tr>
                  <td class="kategorija-naziv" colspan="2">{{ __(kategorija.naziv) }}</td>
                </tr>
                <tr
                  v-for="statusproizvoda in statusiproizvodov(kategorija)">
                  <td>{{ vrniproizvodesstatusom(proizvodi,statusproizvoda,kategorija) }}</td>
                  <td class="status no-wrap">{{ __(statusproizvoda) }}</td>
                </tr>
              </tbody>
            </template>

          </table>
        </div>
        <div class=" seznam seznam-clanov sekcija">


        </div>
        <div v-if="certifikat.dejavnostizadrugo && certifikat.dejavnostizadrugo.length > 0"
          class="seznam seznam-dejavnosti sekcija">
          <div class="naslov-kategorije">
            {{ __("Seznam dejavnosti") }}
          </div>
          <table>
            <thead>
              <tr>
                <td colspan="2">{{ __("Opis dejavnosti iz točke 5 dela I v skladu z Uredbo (EU) 2018/848") }}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="dejavnost in certifikat.dejavnostizadrugo">
                <td>{{ __(dejavnost) }}</td>
                <td class="status">{{ __("Izvajanje dejavnosti kot podizvajalec za drugega izvajalca dejavnosti, medtem ko podizvajalec ostaja odgovoren za dejavnost oziroma dejavnosti, ki se izvajajo")}}</td>
              </tr>
            </tbody>

          </table>
        </div>
        <div v-if="certifikat.informacije" class="seznam seznam-informacij sekcija">
          <div class="naslov-kategorije">
            {{ __("Druge informacije") }}
          </div>
          <div class="vsebina-kategorije">
            {{ certifikat.informacije }}
          </div>
        </div>

        <!-- 8 -->
        <div class="noga-info-group">
          <div v-if="certifikat.stariCertifikat" class="stari-certifikat sekcija">
            {{ __("Ta dokument zamenjuje dokument s številko") }} {{ certifikat.stariCertifikat }}.
          </div>

          <!-- 8  -->


          <div class="pravni-pouk sekcija">
            {{ __("Ta dokument je bil izdan v skladu z Uredbo (EU) 2018/848 kot potrdilo, da izvajalec dejavnosti izpolnjuje zahteve iz navedene uredbe.")}}
          </div>

          <!-- 7 -->
          <div class="noga">
            <div class="vrstica del-2 sekcija">
              <div class="potrditev">
                <div class="naslov">{{ __("Datum/kraj:") }}</div>
                <div class="datum-kraj">{{ certifikat.datumizdaje }}, {{ certifikat.organ_kraj }}</div>
                <div class="naslov">{{ __("Vodja certificiranja:") }}</div>
                <div class="certifikat-podpis">{{ certifikat.organ_podpisnik }}</div>
              </div>
              <div class="veljavnost">
                {{ __("Certifikat je veljaven od") }} {{ certifikat.datumizdaje }} {{ __("do") }}
                {{ certifikat.datumveljavnosti }}
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
@media print {
  @page {
    margin-top: 15mm;
    margin-bottom: 20mm;
    margin-left: 50mm;
    margin-right: 10mm;
  }
}

tr[data-last-split-element] td {
  border: none;
}

.seznam-proizvodov tbody+tbody {
  break-inside: avoid !important;
}

.noga-info-group {
  break-inside: avoid !important;
}


.levi-stolpec {
  position: running(leviStolpecRunning);
  width: 4.5cm;
  padding-left: 1cm;
  height: 27.7cm;
}

/*
297-30-10=257
*/
.levi-stolpec-napis {

  width: 3cm;
  height: 25.7cm;

  justify-self: end;



}

.levi-logo {
  background-image: url('~@/assets/IKC-logo-01.svg');
  background-size: contain;
  background-repeat: no-repeat;
  height: 2cm;
  width: 3cm;
  left: 0px;
  align-self: center;
  background-position: center
}

.eko-napis {
  color: white;
  text-transform: uppercase;
  width: 15cm;
  height: 2cm;
  font-size: 1cm;
  position: absolute;
  transform: rotate(-90deg);
  transform-origin: left top;
  bottom: 0cm;
  left: 2cm;
  text-align: left;
}

.stevilka-strani:before {
  content: "Stran " counter(page) " od " counter(pages);
}

.stevilka-strani.lang-en:before {
  content: "Page " counter(page) " of " counter(pages);
}

.stevilka-strani.lang-de:before {
  content: "Seite " counter(page) " von " counter(pages);
}

.noga-izven {
  position: running(nogaRunning);
  font-size: 3mm;
  line-height: 5mm;

}

@page {


  size: A4 portrait;

  @bottom-center {
    content: element(nogaRunning);
    vertical-align: top;
  }

  @left-middle {
    content: element(leviStolpecRunning);
  }
}
</style>

<script>





import { mapState, mapActions } from 'vuex'
import CertifikatKategorija from './CertifikatKategorija.vue'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { font, fontBold } from './support/includeFont.js'
import { Previewer, registerHandlers, Handler } from 'pagedjs';

class RepeatingTableHeaders extends Handler {
  /* constructor(chunker, polisher, caller) {
     super(chunker, polisher, caller);
   }
 
   afterPageLayout(pageElement, page, breakToken, chunker) {
     // Find all split table elements
     let tables = pageElement.querySelectorAll("table[data-split-from]");
 
     tables.forEach((table) => {
       // Get the reference UUID of the node
       let ref = table.dataset.ref;
       // Find the node in the original source
       let sourceTable = chunker.source.querySelector("[data-ref='" + ref + "']");
       // Find if there is a header
       let header = sourceTable.querySelector("thead");
       if (header) {
         // Clone the header element
         let clonedHeader = header.cloneNode(true);
         // Insert the header at the start of the split table
         table.insertBefore(clonedHeader, table.firstChild);
       }
     });
 
   }
   old but working*/
  constructor(chunker, polisher, caller) {
    super(chunker, polisher, caller);
    this.splitTablesRefs = [];
  }

  afterPageLayout(pageElement, page, breakToken, chunker) {
    this.chunker = chunker;
    this.splitTablesRefs = [];

    if (breakToken) {
      const node = breakToken.node;
      const tables = this.findAllAncestors(node, "table");
      if (node.tagName === "TABLE") {
        tables.push(node);
      }

      if (tables.length > 0) {
        this.splitTablesRefs = tables.map(t => t.dataset.ref);

        //checks if split inside thead and if so, set breakToken to next sibling element
        let thead = node.tagName === "THEAD" ? node : this.findFirstAncestor(node, "thead");
        if (thead) {
          let lastTheadNode = thead.hasChildNodes() ? thead.lastChild : thead;
          breakToken.node = this.nodeAfter(lastTheadNode, chunker.source);
        }

        this.hideEmptyTables(pageElement, node);
      }
    }
  }

  hideEmptyTables(pageElement, breakTokenNode) {
    this.splitTablesRefs.forEach(ref => {
      let table = pageElement.querySelector("[data-ref='" + ref + "']");
      if (table) {
        let sourceBody = table.querySelector("tbody > tr");
        if (!sourceBody || this.refEquals(sourceBody.firstElementChild, breakTokenNode)) {
          table.style.visibility = "hidden";
          table.style.position = "absolute";
          let lineSpacer = table.nextSibling;
          if (lineSpacer) {
            lineSpacer.style.visibility = "hidden";
            lineSpacer.style.position = "absolute";
          }
        }
      }
    });
  }

  refEquals(a, b) {
    return a && a.dataset && b && b.dataset && a.dataset.ref === b.dataset.ref;
  }

  findFirstAncestor(element, selector) {
    while (element.parentNode && element.parentNode.nodeType === 1) {
      if (element.parentNode.matches(selector)) {
        return element.parentNode;
      }
      element = element.parentNode;
    }
    return null;
  }

  findAllAncestors(element, selector) {
    const ancestors = [];
    while (element.parentNode && element.parentNode.nodeType === 1) {
      if (element.parentNode.matches(selector)) {
        ancestors.unshift(element.parentNode);
      }
      element = element.parentNode;
    }
    return ancestors;
  }

  // The addition of repeating Table Headers is done here because this hook is triggered before overflow handling
  layout(rendered, layout) {
    this.splitTablesRefs.forEach(ref => {
      const renderedTable = rendered.querySelector("[data-ref='" + ref + "']");
      if (renderedTable) {
        // this event can be triggered multiple times
        // added a flag repeated-headers to control when table headers already repeated in current page.
        if (!renderedTable.getAttribute("repeated-headers")) {
          const sourceTable = this.chunker.source.querySelector("[data-ref='" + ref + "']");
          this.repeatColgroup(sourceTable, renderedTable);
          this.repeatTHead(sourceTable, renderedTable);
          renderedTable.setAttribute("repeated-headers", true);
        }
      }
    });
  }

  repeatColgroup(sourceTable, renderedTable) {
    let colgroup = sourceTable.querySelectorAll("colgroup");
    let firstChild = renderedTable.firstChild;
    colgroup.forEach((colgroup) => {
      let clonedColgroup = colgroup.cloneNode(true);
      renderedTable.insertBefore(clonedColgroup, firstChild);
    });
  }

  repeatTHead(sourceTable, renderedTable) {
    let thead = sourceTable.querySelector("thead");
    if (thead) {
      let clonedThead = thead.cloneNode(true);
      renderedTable.insertBefore(clonedThead, renderedTable.firstChild);
    }
  }

  // the functions below are from pagedjs utils/dom.js
  nodeAfter(node, limiter) {
    if (limiter && node === limiter) {
      return;
    }
    let significantNode = this.nextSignificantNode(node);
    if (significantNode) {
      return significantNode;
    }
    if (node.parentNode) {
      while ((node = node.parentNode)) {
        if (limiter && node === limiter) {
          return;
        }
        significantNode = this.nextSignificantNode(node);
        if (significantNode) {
          return significantNode;
        }
      }
    }
  }

  nextSignificantNode(sib) {
    while ((sib = sib.nextSibling)) {
      if (!this.isIgnorable(sib)) return sib;
    }
    return null;
  }

  isIgnorable(node) {
    return (node.nodeType === 8) || // A comment node
      ((node.nodeType === 3) && this.isAllWhitespace(node)); // a text node, all whitespace
  }

  isAllWhitespace(node) {
    return !(/[^\t\n\r ]/.test(node.textContent));
  }

}

registerHandlers(RepeatingTableHeaders);





import ikcLogo from "../assets/ikc.png"
export default {
  props: ["certifikatid"],
  components: { "kategorija": CertifikatKategorija },


  data: function () {
    return {
      stDokumenta: "00001",
      vrstaCertifikata: "Izvajalec dejavnosti",
      subjekt: { naziv: "Bethanie Wiggins", naslov: "Baragov trg 12, 4000 Kranj" },
      organ: { ime: "Inštitut za kontrolo in certifikatcijo UM", naslov: "Pivola 8, 2311 Hoče", šifra: "SI-EKO-002" },
      pridelava: { rastline: { eko: ["Koleraba", "Trava"] }, živali: { eko: ["Apake", "Konji, starejši od enega leta"], preusmeritev: ["Fazani"] }, alge: {} },
      predelava: {},
      krma: {},
      vino: {},
      ostalo: {},
      kategorije: [
        { id: "a", naziv: "rastline", sloNaziv: "Nepredelane rastline in rastlinski proizvodi, vključno s semeni in drugim rastlinskim razmnoževalnim materialom", angNaziv: "Unprocessed plants and plant products, including seeds and other plant reproductive material" },
        { id: "b", naziv: "živali", sloNaziv: "Živina in nepredelani proizvodi iz živine", angNaziv: "Livestock and unprocessed livestock products" },
        { id: "c", naziv: "alge", sloNaziv: "Alge in nepredelani proizvodi iz akvakulture", angNaziv: "Algae and unprocessed aquaculture products" },
        { id: "d", naziv: "proizvodi", sloNaziv: "Predelani kmetijski proizvodi, vključno s proizvodi iz akvakulture, namenjeni za hrano", angNaziv: "Processed agricultural products, including aquaculture products, for use as food" },
        { id: "e", naziv: "krma", sloNaziv: "Krma", angNaziv: "Feed" },
        { id: "f", naziv: "vino", sloNaziv: "Vino", angNaziv: "Wine" },
        { id: "g", naziv: "ostalo", sloNaziv: "Ostali proizvodi iz Priloge I k Uredbi (EU) 2018/848 ali proizvodi, ki ne spadajo v prej navedene kategorije", angNaziv: "Other products listed in Annex I to Regulation (EU) 2018/848 or not covered by the previous categories" }
      ]
      // certifikat:{}

    }
  },
  computed: {
    ...mapState({
      certifikat(state) {

        return state.certifikat.certifikat;
      }
    }),
    jezik: {
      get() {
        var l = {};
        l["lang-" + this.$route.query.lang] = true;
        return l;
      }
    },
    proizvodi:
    {
      get() {
        if (!this.certifikat.vsiproizvodi)
          return [];
        else
          return this.certifikat.vsiproizvodi.filter(i => i.statuspridelkanaziv != 'Neekološki').sort(
            (a, b) => {
              var x = a.vrstapridelkaid - b.vrstapridelkaid;
              if (x)
                return x;
              else {

                return a.certifikat.localeCompare(b.certifikat);
              }
            });

      },
    }

  },
  methods: {

    ...mapActions('certifikat', ['vrniPoId']),
    statusiproizvodov(kategorija)
    {
        return this.proizvodi
                      .filter(p => (p.kategorija == kategorija.id && !(kategorija.id == 'b' && p.statuspridelkanaziv == 'Iz preusmeritve') && p.statuspridelkanaziv != '1. leto preusmeritve'))
                      .reduce((acc, p) => { if (!acc.includes(p.statuspridelkanaziv)) { acc.push(p.statuspridelkanaziv); } return acc; }, [])
    
    },
    vrniproizvodesstatusom(proizvodi,status,kategorija){
      console.log("proizvodi");
      console.log(proizvodi);
      return proizvodi
      .filter(p => (p.kategorija == kategorija.id && !(kategorija.id == 'b' && p.statuspridelkanaziv == 'Iz preusmeritve') 
      && p.statuspridelkanaziv != '1. leto preusmeritve')
      &&p.statuspridelkanaziv==status)
      .map(p=>p.certifikat)
      .join(", ");
                      

    },
    __p: function (value) {

      if (!this.$route.query.lang)
        return value.certifikat


      else
        return value.info[this.$route.query.lang];


    },

    __: function (value) {

      if (!this.$route.query.lang)
        return value


      let lang = this.$route.query.lang
      var translation = {};

      translation["en"] = {
        "CERTIFIKAT": "CERTIFICATE",
        "Številka dokumenta:": "Document number:",
        "Izvajalec dejavnosti": "Operator",
        "Ime in naslov izvajalca dejavnosti:": "Name and address of the operator:",
        "Ime in naslov izvajalca nadzora ter šifra:": "Name and address of the control body and code number:",
        "Dejavnosti izvajalca dejavnosti:": "Activity or activities of the operator:",
        "Kategorije proizvodov iz člena 35(7) Uredbe (EU) 2018/848 Evropskega parlamenta in Sveta (1) ter metode pridelave:": "Category or categories of products as referred to in Article 35(7) of Regulation (EU) 2018/848 of the European Parliament and of the Council (1) and production methods:",
        "(a) nepredelane rastline in rastlinski proizvodi, vključno s semeni in drugim rastlinskim razmnoževalnim materialom": "(a) unprocessed plants and plant products, including seeds and other plant reproductive material",

        "(b) živina in nepredelani proizvodi iz živine": "(b) livestock and unprocessed livestock products",
        "(c) alge in nepredelani proizvodi iz akvakulture:": "(c) algae and unprocessed aquaculture products",
        "(d) predelani kmetijski proizvodi, vključno s proizvodi iz akvakulture, namenjeni za hrano": "(d) processed agricultural products, including aquaculture products, for use as food",
        "(e) krma": "(e) feed",
        "(f) vino": "(f) wine",
        "(g) ostali proizvodi iz Priloge I k Uredbi (EU) 2018/848 ali proizvodi, ki ne spadajo v prej navedene kategorije": "(g) other products listed in Annex I to Regulation (EU) 2018/848 or not covered by the previous categories",


        "Nepredelane rastline in rastlinski proizvodi, vključno s semeni in drugim rastlinskim razmnoževalnim materialom": "Unprocessed plants and plant products, including seeds and other plant reproductive material",
        "Živina in nepredelani proizvodi iz živine": "Livestock and unprocessed livestock products",
        "Alge in nepredelani proizvodi iz akvakulture:": "Algae and unprocessed aquaculture products",
        "Predelani kmetijski proizvodi, vključno s proizvodi iz akvakulture, namenjeni za hrano": "Processed agricultural products, including aquaculture products, for use as food",
        "Krma": "Feed",
        "Vino": "Wine",
        "Ostali proizvodi iz Priloge I k Uredbi (EU) 2018/848 ali proizvodi, ki ne spadajo v prej navedene kategorije": "Other products listed in Annex I to Regulation (EU) 2018/848 or not covered by the previous categories",



        "Ekološko kmetijstvo": "Organic production",
        "Ekološki": "Organic",
        "Iz preusmeritve": "In-conversion",

        "Pridelava": "Production",
        "Priprava": "Preparation",
        "Distribucija / Dajanje v promet": "Distribution/Placing on the market",
        "Skladiščenje": "Storing",
        "Uvoz": "Import",
        "Izvoz": "Export",

        "Seznam proizvodov": "Directory of products",
        "Ime proizvoda in/ali oznaka kombinirane nomenklature (KN) iz Uredbe Sveta (EGS) št. 2658/87 za proizvode s področja uporabe Uredbe (EU) 2018/848": "Name of the product and/or Combined Nomenclature (CN) code as referred to in Council Regulation (EEC) No 2658/87 for products within the scope of Regulation (EU) 2018/848",
        "Status": "Status",
        "Seznam dejavnosti": "List of activities:",
        "Opis dejavnosti iz točke 5 dela I v skladu z Uredbo (EU) 2018/848": "Description of the activity or activities as referred to in point 5 of part I in accordance with Regulation (EU) 2018/848",
        "Izvajanje dejavnosti kot podizvajalec za drugega izvajalca dejavnosti, medtem ko podizvajalec ostaja odgovoren za dejavnost oziroma dejavnosti, ki se izvajajo": "Carrying out activity/activities as a subcontractor for another operator, while the subcontractor remains responsible for the activity or activities performed",
        "Druge informacije": "Other information",
        "Ta dokument zamenjuje dokument s številko": "This document replaces the document with the number",
        "Ta dokument je bil izdan v skladu z Uredbo (EU) 2018/848 kot potrdilo, da izvajalec dejavnosti izpolnjuje zahteve iz navedene uredbe.": "This document has been issued in accordance with Regulation (EU) 2018/848 to certify that the operator or group of operators complies with that Regulation.",
        "Datum/kraj:": "Date/place:",
        "Direktor:": "Director:",
        "Vodja certificiranja:": "Vodja certificiranja:",
        "Certifikat je veljaven od": "Certificate valid from",
        "do": "to",
        "telefon": "telephone"

      };


      translation["de"] = {
        "CERTIFIKAT": "ZERTIFIKAT",
        "Številka dokumenta:": "Nummer des Zertifikats:",
        "Izvajalec dejavnosti": "Unternehmer",
        "Ime in naslov izvajalca dejavnosti:": "Name und Anschrift des Unternehmers:",
        "Ime in naslov izvajalca nadzora ter šifra:": "Name und Anschrift der Kontrollbehörde und die Codenummer:",
        "Dejavnosti izvajalca dejavnosti:": "Tätigkeit(en) des Unternehmers:",
        "Kategorije proizvodov iz člena 35(7) Uredbe (EU) 2018/848 Evropskega parlamenta in Sveta (1) ter metode pridelave:": "Erzeugniskategorie(n) gemäß Artikel 35 Absatz 7 der Verordnung (EU) 2018/848 des Europäischen Parlaments und des Rates und Produktionsverfahren:",
        "(a) nepredelane rastline in rastlinski proizvodi, vključno s semeni in drugim rastlinskim razmnoževalnim materialom": "(a) unprocessed plants and plant products, including seeds and other plant reproductive material",

        "(b) živina in nepredelani proizvodi iz živine": "(b) livestock and unprocessed livestock products",
        "(c) alge in nepredelani proizvodi iz akvakulture:": "(c) algae and unprocessed aquaculture products",
        "(d) predelani kmetijski proizvodi, vključno s proizvodi iz akvakulture, namenjeni za hrano": "(d) processed agricultural products, including aquaculture products, for use as food",
        "(e) krma": "(e) feed",
        "(f) vino": "(f) wine",
        "(g) ostali proizvodi iz Priloge I k Uredbi (EU) 2018/848 ali proizvodi, ki ne spadajo v prej navedene kategorije": "(g) other products listed in Annex I to Regulation (EU) 2018/848 or not covered by the previous categories",


        "Nepredelane rastline in rastlinski proizvodi, vključno s semeni in drugim rastlinskim razmnoževalnim materialom": "Unverarbeitete Pflanzen und Pflanzenerzeugnisse, einschließlich Saatgut und anderes Pflanzenvermehrungsmaterial",
        "Živina in nepredelani proizvodi iz živine": "Tiere und unverarbeitete tierische Erzeugnisse",
        "Alge in nepredelani proizvodi iz akvakulture:": "Algen und unverarbeitete Aquakulturerzeugnisse",
        "Predelani kmetijski proizvodi, vključno s proizvodi iz akvakulture, namenjeni za hrano": "Verarbeitete landwirtschaftliche Erzeugnisse, einschließlich Aquakulturerzeugnisse, die zur Verwendung als Lebensmittel bestimmt sind",
        "Krma": "Futtermittel",
        "Vino": "Wein",
        "Ostali proizvodi iz Priloge I k Uredbi (EU) 2018/848 ali proizvodi, ki ne spadajo v prej navedene kategorije": "Andere in Anhang I der Verordnung (EU) 2018/848 aufgeführte Erzeugnisse oder nicht durch die vorstehenden Kategorien erfasste Erzeugnisse",



        "Ekološko kmetijstvo": "Ökologische Produktion",
        "Ekološki": "Ökologisch/biologisch",
        "Iz preusmeritve": "in Umstellung",

        "Pridelava": "Produktion",
        "Priprava": "Aufbereitung",
        "Distribucija / Dajanje v promet": "Vertrieb/Inverkehrbringen",
        "Skladiščenje": "Lagerung",
        "Uvoz": "Einfuhr",
        "Izvoz": "Ausfuhr",

        "Seznam proizvodov": "Verzeichnis der Erzeugnisse",
        "Ime proizvoda in/ali oznaka kombinirane nomenklature (KN) iz Uredbe Sveta (EGS) št. 2658/87 za proizvode s področja uporabe Uredbe (EU) 2018/848": "Name des Erzeugnisses und/oder Code-Nummer der Kombinierten Nomenklatur (KN-Code) gemäß der Verordnung (EWG) Nr. 2658/87 des Rates (1) für Erzeugnisse im Geltungsbereich der Verordnung (EU) 2018/848",
        "Status": "Status",
        "Seznam dejavnosti": "Verzeichnis der Tätigkeiten:",
        "Opis dejavnosti iz točke 5 dela I v skladu z Uredbo (EU) 2018/848": "Beschreibung der Tätigkeit(en) gemäß Teil I Feld 5 gemäß der Verordnung (EU) 2018/848",
        "Izvajanje dejavnosti kot podizvajalec za drugega izvajalca dejavnosti, medtem ko podizvajalec ostaja odgovoren za dejavnost oziroma dejavnosti, ki se izvajajo": "Ausübung der Tätigkeit(en) als Subunternehmer für einen anderen Unternehmer, wobei der Subunternehmer für die ausgeübte(n) Tätigkeit(en) verantwortlich bleibt",
        "Druge informacije": "Weitere Angaben",
        "Ta dokument zamenjuje dokument s številko": "Dieses Dokument ersetzt das Dokument mit der Nummer",
        "Ta dokument je bil izdan v skladu z Uredbo (EU) 2018/848 kot potrdilo, da izvajalec dejavnosti izpolnjuje zahteve iz navedene uredbe.": "Dieses Dokument wurde gemäß der Verordnung (EU) 2018/848 ausgestellt, um zu bestätigen, dass der Unternehmer oder die Unternehmergruppe (Nichtzutreffendes streichen) die Anforderungen dieser Verordnung erfüllt.",
        "Datum/kraj:": "Datum/Ort:",
        "Direktor:": "Direktor:",
        "Vodja certificiranja:": "Vodja certificiranja:",
        "Certifikat je veljaven od": "Zertifikat gültig vom",
        "do": "bis zum",
        "telefon": "telefon"

      };

      if (!translation[lang])
        return value;

      return translation[lang][value] ? translation[lang][value] : value;


    }



  },
  created() {

    console.log("Page refresh, checking properties");
    console.log(this.certifikatid);

    this.vrniPoId({ id: this.certifikatid }).then(() => {
      var stcertifikata = this.certifikat.stcertifikata;
      console.log(this.gridData);
      this.$nextTick(function () {
        var pdf = new jsPDF({ orientiation: 'p', unit: 'pt', format: 'a4' });
        //pdf.advancedAPI(pdf=>{
        //pdf.addFileToVFS("MyFont.ttf", myFont);
        //pdf.addFont("MyFont.ttf", "MyFont", "normal");
        pdf.addFileToVFS('republika-regular-webfont-normal.ttf', font);
        pdf.addFileToVFS('republika-regular-webfont-bold.ttf', fontBold);
        console.log("Moj Font!");
        console.log(font);

        pdf.addFont('republika-regular-webfont-normal.ttf', 'Republika', 'normal');
        pdf.addFont('republika-regular-webfont-bold.ttf', 'Republika', 'bold');
        pdf.setFont("Republika");

        console.log(document.getElementById('html'));
        let html = document.getElementById('html');

        let paged = new Previewer();


        //var win = window.open("", "pdf");
        /*let flow = paged.preview(html, [], html.parentNode).then((flow) => {
        console.log(flow);
          console.log("Rendered", flow.total, "pages.");
        })
        */
        paged.preview();
        /*
            pdf.html(document.getElementById('html'), {
              margin: [30, 30, 50, 140],
              autoPaging:'text',
              width:435,
              //y:77,
              windowWidth:800,
              callback: function (pdf) {
                //var iframe = document.createElement('iframe');
                //iframe.setAttribute('style', 'position:absolute;right:0; top:0; bottom:0; height:100%; width:500px');
                //document.body.appendChild(iframe);
                //iframe.src = pdf.output('primer.pdf');
                console.log("Callback called!");
        
        
                const pageCount = pdf.internal.getNumberOfPages()
                pdf.setFontSize(8);
                 pdf.setFont("Republika");
                for (var i = 1; i<= pageCount; i++) {
                  console.log(pdf);
                //pdf.addPage('a4','p');
                pdf.setPage(i);
                console.log("pišem na page " + i);
                console.log(pdf.internal);
                pdf.addImage(ikcLogo ,'PNG',30,20,90,62.3);
                //console.log(sideBar);
                pdf.setDrawColor("#098846");
                pdf.setFillColor("#098846");
                pdf.path([
                  {op: "m", c: [120,77]},
                  {op: "l", c: [120,800]},
                  {op: "c", c: [120,810,110,820,100,820]},
                  {op: "l", c: [20,820]},
                  {op: "l", c: [20,117]},
                  {op: "c", c: [20,97,40,77,60,77]},
                  {op: "l", c: [120,77]}
                  ]
                  );
                //pdf.addSvgAsImage(sideBar, 20, 60, 120,680,'SLOW');
                pdf.fillStroke();
                pdf.setFontSize(30);
                pdf.setTextColor("#FFFFFF");
                pdf.text('EKOLOŠKO KMETIJSTVO',80,800, {
                  angle:90
              })
                  pdf.setTextColor("#000000");
                 pdf.setFontSize(8);
                pdf.text('Stran ' + String(i) + ' od ' + String(pageCount),((pdf.internal.pageSize.width-180) / 2)+160, 806, {
                  align: 'center'
              })
                pdf.text('Pivola 8, SI-2331 Hoče, telefon: + 386 (0)2 6130831, -32, e-mail: info@ikc-um.si, www.ikc-um.si', ((pdf.internal.pageSize.width-180) / 2)+160, 816,  {
                  align: 'center'
              })
            console.log("Končal z page " + i);
        
          }
         
            
                pdf.save(stcertifikata+".pdf");
              }
              //})
            });
         konec jspdf */




      });
    });



    //this.id=this.$route.query.id;
    //this.vrniPoId({id:this.id});

  },
  mounted() {

  }
}
</script>
<style scoped>
.seznam-proizvodov thead td:nth-child(2) {
  w-idth: 100px;
}

.noga .sekcija {
  margin-bottom: 0;
}

.seznam table {
  border-collapse: collapse;
  width: 100%;
}

.naslov {
  margin-bottom: 1em;
}


.seznam tbody td.kategorija-naziv {
  background-color: var(--accent);
  color: white;
  font-weight: bold;

}

.seznam thead td,
td.kategorija-naziv {
  border-top: 1px solid var(--accent);
  border-right: 1px solid var(--accent);

}

.seznam td:nth-child(2) {

  border-right: 1px solid var(--accent);
}

.seznam td {
  -border: 1px solid var(--accent);
  border-left: 1px solid var(--accent);
  border-bottom: 1px solid var(--accent);
  padding: 0.5em;
  text-align: left;
  border-collapse: collapse;


}

.certifikat.ovoj h3 {
  font-size: 2em;
}


.no-wrap {
  white-space: nowrap;
}

.certifikat.ovoj {

  font-size: 3mm;
  color: #111;
  font-family: "Republika", arial, helvetica, sans-serif;
}

.glava.mali-ovoj {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.desni-logo {

  background-image: url('~@/assets/cp012.jpg');
  background-size: contain;
  background-repeat: no-repeat;
  background-color: white;

  height: 15mm;
  width: 40mm;
  margin-right: 15mm;

}


.glava.certifikat {


  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 1em;
  text-decoration: none;
  justify-content: center;
  flex-grow: 1;

}

.glava.certifikat h1 {
  font-size: 9mm;
  margin: 4mm;
  letter-spacing: 4mm;
  line-height: 9mm;

}

.vrstica {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;

  margin-bottom: 1em;
}

.vrstica>div,
.seznam-informacij .vsebina-kategorije {
  border: 1px solid var(--accent);
  padding: 0.5em;
}

.vrstica>div:nth-child(1) {
  border-right: none;

}

.naslov {

  text-decoration: underline;
}

.sekcija {
  margin-bottom: 3mm;


}

.naziv-nosilca,
.naslov-nosilca,
.naziv-izvajalca,
.naslov-izvajalca,
.sifra-izvajalca,
.stevilka-certifikata>.stevilka-certifikata,
.dejavnosti-izvajalca li {
  color: var(--accent);
  font-size: 1.2em;
  font-weight: bold;

}

.seznam tbody td {
  color: var(--accent);
  font-weight: bold;
}


.certifikat.ovoj {
  /* change the margins as you want them to be. */

}
</style>
